import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import FormNumber from "../../Form/FormNumber";
import InputAdornment from "@material-ui/core/InputAdornment";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class SectionalDoors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <Typography className={classes.textRight} component={"div"}*/}
                        {/*                variant={"body1"}>*/}
                        {/*        Geräteart/-typ*/}
                        {/*    </Typography>*/}
                        {/*</Grid>*/}
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                                inputProps={{
                                    max : 2100,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="gate_size"
                                label='Torflügelgröße (mm):'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.gate_size}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="inventory_number"
                                label='Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <Typography className={classes.textLeft} component={"div"}
                                        variant={"body1"}>
                                Mw Messung HSK<br />(H:220, L+R 200mm und Mitte):
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number"
                                label='Seriennummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="location"
                                label='Einbauort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.location}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="f_dyn"
                                label='F dyn:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.f_dyn}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="t_dyn"
                                label='t dyn:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.t_dyn}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <FormField
                                type="number"
                                name="f_end"
                                label='F end:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.f_end}
                                inputProps={{
                                    maxLength : 5,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormField
                                type="text"
                                name="control_type"
                                label='Art der Steuerung (z.B. Taster, Zugschalter, Lichtschranke, Radar, Infrarot, Kontaktschwelle):'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.control_type}
                                inputProps={{
                                    maxLength : 30,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                1. Gewichtsausgleich
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Welle, Lager
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Wellenkupplung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Konsolenbefestigung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_3 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Gurt-/Seilbefestigung am Trommel-/Gewichtsausgleich
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_4 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                e) Gurt-/Seilbefestigung am Torblatt
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_5 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                f) Gurte/Seile
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_6"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_6 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                g) Gurt-/Seiltrommel
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_7"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_7 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                h) Federfunktion, Kontrolle des Gewichtsausgleichs
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_8"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_8 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                i) Spannköpfe/Federlager
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_9"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_9 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                j) Seilschalter
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_10"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_10 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                k) Prüfung Torlauf v. Hand b. ausgekuppeltem Antrieb
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_1_content_11"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_1_content_11 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                2. Antrieb
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Antriebs- und Konsolenbefestigung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_2_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_2_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Geräusche und Dichtheit des Antriebes
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_2_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_2_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Nothandbetätigung und elektr. Verriegelung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_2_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_2_content_3 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Bremswirkung, Nachlauf
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_2_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_2_content_4 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                e) Ausrückkupplung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_2_content_5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_2_content_5 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                3. Schaltautomat und Steuergeräte
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Betriebsendschaltereinstellung und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Sicherheitsendschaltereinstellung und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Zusatzendschaltereinstellung und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_3 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Einstellung des Motorschutzschalters
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_4 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                e) elektr. u. mech. Funktion der Befehlsgeber
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_5 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                f) elektr. Verriegelung Schlupftür o. Geh-/Drehflügel
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_3_content_6"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_3_content_6 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                4. Kettenradvorgelege (soweit vorhanden)
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Kette: Fluchten und Verschleiß
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_4_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_4_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Kette: Spannung, ggf. nachspannen
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_4_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_4_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Kette: Sauberkeit, Schmierung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_4_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_4_content_3 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Kettenräder: Verschleiß, fester Sitz
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_4_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_4_content_4 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                5. Sicherung gegen unbeabsichtigtes Schließen des Torflügels
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                A) Sicherungen, die auf die Welle wirken
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={1}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                1.
                            </Typography>
                        </Grid>
                        <Grid item md={8} xs={5}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Selbsthemmender und/oder mit Bremse versehener Antrieb ohne Entkupplungsmöglichkeit
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'ja'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'nein'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_1 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                2.
                            </Typography>
                        </Grid>
                        <Grid item md={8} xs={5}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Antrieb in Verbindung m. Fangvorrichtung o. zusätzlichen Bauteilen, die bei Bruch
                                tragender Teile des Getriebes einen Absturz des Flügels verhindern
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'ja'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'nein'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_2 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                3.
                            </Typography>
                        </Grid>
                        <Grid item md={8} xs={5}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Federbruchsicherung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'ja'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'nein'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_3 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                5. Sicherung gegen unbeabsichtigtes Schließen des Torflügels
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                B) Sicherungen, die auf die Flügel wirken
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={1}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                1.
                            </Typography>
                        </Grid>
                        <Grid item md={8} xs={5}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Schienenfangvorrichtung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'ja'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'nein'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_4 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                2.
                            </Typography>
                        </Grid>
                        <Grid item md={8} xs={5}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Seilaufhängungen mit Sperrklinken (Klauen/Zahnscheiben) zur Schlaffseil- u./o.
                                Seilbruchsicherung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'ja'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'nein'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_5 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                C) Prüfung für A und/oder B
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Befestigung und Zustand
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_6"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_6 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) bewegl. Teile: Verschleiß, Korrosion, Gängigkeit
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_7"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_7 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Schild: Vollständigkeit, Lesbarkeit
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_8"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_8 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) elektr. Abschaltung d. Antriebes
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_9"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_9 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                e) Funktionskontrolle nach Angaben des Herstellers
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_5_content_10"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_5_content_10 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                6. Torflügel
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Verschleiß, Seitenarretierung, Deformation
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Scharniere und Laufrollen
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Laufrolleneinstellung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_3 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Windaussteifung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_4 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                e) Zustand Verglasung/Füllung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_5 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                f) Schlupftür mit Obertürschließer
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_6_content_6"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_6_content_6 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                7. Sicherung der Hauptschließkante
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Zustand und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_7_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_7_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={6} xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Lichtschranke(n) (Höhe angeben)
                            </Typography>
                        </Grid>
                        <Grid xs={2}>
                            <FormNumber
                                type="text"
                                name="check_7_content_2_height"
                                onChange={handleChange}
                                value={this.state.value}
                                fixedDecimalScale={false}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">mm</InputAdornment>
                                }}
                            />
                        </Grid>
                        <Hidden smDown>
                            <Grid item xs={1}>
                                &nbsp;
                            </Grid>
                        </Hidden>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_7_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_7_content_2 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                8. Führungsschienen/Rahmenteile
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Befestigung und Zustand (Deformation)
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_8_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_8_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Verschleiß und Schmierung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_8_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_8_content_2 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                c) Zargendichtung
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_8_content_3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_8_content_3 || ''}
                            />
                        </Grid>

                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                d) Enddämpfer
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_8_content_4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_8_content_4 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                9. Sicherung Quetsch- und Scherstellen (soweit notwendig)
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Zustand und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_9_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_9_content_1 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                10. Kennzeichnungsschild
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Vollständigkeit und Lesbarkeit
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_10_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_10_content_1 || ''}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"h6"}>
                                11. Abschchließbarer Hauptschalter/CCE-Stecker
                            </Typography>
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                a) Vorhanden
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_11_content_1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_11_content_1 || ''}
                            />
                        </Grid>
                        <Grid item md={9} xs={6}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                b) Zustand und Funktion
                            </Typography>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <FormRadio
                                name="check_11_content_2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'B.'
                                    },
                                    {
                                        value : 'free',
                                        label : 'frei'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.check_11_content_2 || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <FormField
                        type="text"
                        name="reason"
                        label='Befund / Mängel / Bemerkungen'
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.reason}
                    />
                </Grid>
                {/*<Grid item xs={6}>*/}
                {/*    <FormField*/}
                {/*        type="text"*/}
                {/*        name="notations"*/}
                {/*        label='Befund / Mängel / Bemerkungen'*/}
                {/*        multiline*/}
                {/*        onChange={handleChange}*/}
                {/*        onBlur={handleBlur}*/}
                {/*        value={values.notations}*/}
                {/*    />*/}
                {/*</Grid>*/}

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    rightSide: {
        marginTop: '-135px',
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px'
    },
    formButton: {
    },
    formSelection: {
        flexDirection: "row",
    },
});

export default withStyles(styles)(SectionalDoors)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/SectionalDoors.js